<template>
  <div>
    <button :title="$t('buttons.manageAccess')" :aria-label="$t('buttons.manageAccess')" class="action" @click="show" id="manage-spaces">
      <users-icon size="1.5x" class="custom-class"></users-icon>
      <span v-if="!isMobile">{{ $t('buttons.manageAccess') }}</span>
      <span v-else>{{ $t('buttons.manageAccessMobile') }}</span>
    </button>
  </div>
</template>

<script>
import { UsersIcon } from 'vue-feather-icons';

export default {
  name: 'manage-access',
  components: {
    UsersIcon,
  },
  computed: {
    isMobile () {
      return window.innerWidth <= 768;
    },
  },
  methods: {
    show() {
      this.$store.commit('showHover', 'manage-access');
    },
  }
};
</script>